import styled from 'styled-components';

const FloatSection = styled.div`
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 4px 8px 0 rgba(0, 0, 0, 0.19);
  padding: 0.5em;
  margin: 1em 0 1.5em 0;
`;

export default FloatSection;
